import useSWR from 'swr';
import { fetcher } from '../base';

export function useBanner({ country = null, skip = false } = {}) {
  const url = country == null ? `/banner` : `/banner/${country}`;
  return useSWR(url, fetcher, { skip, revalidateOnFocus: false });
}
